import React from 'react';
import Alert from "@material-ui/lab/Alert";
import {Card} from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import BallotSharpIcon from '@material-ui/icons/BallotSharp';
import HistoricPqrs from "./HistoricPqrs";
import Api from "../../helpers/Api";
import Env from "../../config/env";
import AppToast from "../../ui/AppToast";
import Tooltip from "@material-ui/core/Tooltip";
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import FilesPqr from "./FilesPqr";

class ListPqr extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            open: false,
            historicSeleted: [],
            codePqr: '',
            openFilesDialog: false,
            filesPqr: []
        };

        this.handleCloseDialog = this.handleCloseDialog.bind(this);
    }

    handleViewDetail = (obj) => {
        this.getHistoricPqrs(obj.pqr_no)
    }

    getHistoricPqrs = async (consecutive) => {
        let params = {
            consecutive: consecutive
        }
        const data = await Api.post(`${Env.UrlBackend}/get-history-pqr`, params);
        if (!data.success) {
            AppToast(data.message, false);
        }
        this.setState({
            historicSeleted: data.data,
            open: true,
            codePqr: consecutive,
        });

        if(data.data.length === 0) {
            AppToast(`El PQR ${this.state.codePqr} No tiene trazabilidad aún.`);
        }

    }

    handleViewFiles = (obj) => {
        this.getFilesPqr(obj.pqr_no);
    }

    getFilesPqr = async (consecutive) => {
        let params = {
            pqr: consecutive
        }
        const data = await Api.post(`${Env.UrlBackend}/get-list-files`, params);
        if (!data.success) {
            AppToast(data.message, false);
        }
        this.setState({
            filesPqr: data.data,
            openFilesDialog: true,
            codePqr: consecutive,
        });
        if(data.data.length === 0) {
            AppToast(`El PQR ${this.state.codePqr} No tiene archivos adjuntos!.`);
        }
    }

    handleCloseDialog = () => {
        this.setState({open: false});
    }

    handleCloseFilesDialog = () => {
        this.setState({openFilesDialog: false});
    }

    render() {
        const {data} = this.props;

        if (data.length === 0) {
            return (
                <div>
                    <br/>
                    <Alert severity="info">No ha creado ninguna PQR!</Alert>
                </div>
            );
        }

        return (
            <Card style={{marginTop: '1%', marginBottom: '2%'}}>

                {
                    (this.state.historicSeleted.length > 0 && this.state.codePqr) ?
                        <HistoricPqrs
                            open={this.state.open}
                            onClose={this.handleCloseDialog}
                            historic={this.state.historicSeleted}
                            codePqr={this.state.codePqr}
                        /> : null
                }

                {
                    (this.state.filesPqr.length > 0 && this.state.codePqr) ?
                        <FilesPqr
                            open={this.state.openFilesDialog}
                            onClose={this.handleCloseFilesDialog}
                            filesPqr={this.state.filesPqr}
                            codePqr={this.state.codePqr}
                        /> : null
                }

                <table className='custom-table'>
                    <thead>
                    <tr>
                        <th>Nro. PQR</th>
                        <th>Observación</th>
                        <th style={{width: '12%'}}>Fecha</th>
                        <th>Estado</th>
                        <th colSpan='2'>Acciones</th>
                    </tr>
                    </thead>
                    <tbody>

                    {data.map((val, index) => {
                        return (
                            <tr key={index}>
                                <td>{val.pqr_no}</td>
                                <td>{val.observaciones}</td>
                                <td>{val.fecha_accion}</td>
                                <td>{val.estado}</td>
                                <td>
                                    <Tooltip title="Ver trazabilidad del PQR">
                                        <IconButton color="secondary" onClick={() => {
                                            this.handleViewDetail(val)
                                        }} aria-label="add to shopping cart">
                                            <BallotSharpIcon/>
                                        </IconButton>
                                    </Tooltip>
                                </td>
                                <td>
                                    <Tooltip title="Ver archivos adjuntos">
                                        <IconButton color="primary" onClick={() => {
                                            this.handleViewFiles(val)
                                        }} aria-label="add to shopping cart">
                                            <InsertDriveFileIcon/>
                                        </IconButton>
                                    </Tooltip>
                                </td>
                            </tr>
                        );
                    })}

                    </tbody>
                </table>
            </Card>
        );
    }
}

export default ListPqr